import { Partner, ShoppingCart } from 'app/api/@generated/backend';

import { EcomDataLayerEventType } from 'app/data-layers/model/data-layer-event-types';
import { getExtraUnitItem, getSelectedHouseData } from 'app/data-layers/utils/data-layer-items-utils';
import { HouseType } from 'app/pages/order/model/house-type';
import { DataLayerUtils } from 'app/data-layers/utils/data-layer-utils';

import { pushFunnelEventStep } from './push-funnel-event-step';

export const pushViewItemListEvent = (shoppingCart: ShoppingCart, partner?: Partner) => {
    pushFunnelEventStep(EcomDataLayerEventType.VIEW_ITEM_LIST, partner);

    const mediumHouse = getSelectedHouseData(shoppingCart, HouseType.MEDIUM_HOUSE, partner);
    const largeHouse = getSelectedHouseData(shoppingCart, HouseType.LARGE_HOUSE, partner);
    const extraUnit = getExtraUnitItem(shoppingCart, partner);

    DataLayerUtils.pushEcomEventToDataLayer({
        event: EcomDataLayerEventType.VIEW_ITEM_LIST,
        ecommerce: {
            items: [mediumHouse, largeHouse, extraUnit],
        },
    });
};
